import { useEffect, useState } from 'react';
import { Button, Modal } from '@skupreme/shared/ui';
import { ToastMessage } from '@utility/toast';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { ErrorMessageConstant } from '@utility/constants/common';
import {
  ControlledTextAreaFormField,
  DateFormField,
} from '@elements/FormField';
import PurchaseOrdersService from '@utility/services/purchase-order';
import { LoaderBar } from '@components/LoaderBar';
import { AppModalHeader, AppModalXIcon } from '@elements/Modal';

const extendSchema = yup.object().shape({
  comment: yup
    // @ts-expect-error - TS2554: Expected 0 arguments, but got 1.
    .string('Comment is Required Field')
    .required('Comment is Required Field'),
  estimated_completion: yup
    // @ts-expect-error - TS2554: Expected 0 arguments, but got 1.
    .date('Date is Required Field')
    .typeError('Date is Required Field')
    .required('Date is Required Field'),
});

export function ExtendDeadlinePopup({ data, open, closeModal }) {
  const {
    formState: { errors },
    control,
    handleSubmit,
    reset,
  } = useForm({
    resolver: yupResolver(extendSchema),
    shouldUnregister: true,
  });

  useEffect(() => {
    reset({});
  }, [open]);

  const [saving, setSaving] = useState(false);

  const onSubmit = async formData => {
    try {
      setSaving(true);
      await PurchaseOrdersService.interalAction(data?._id, {
        action_status: data?.status,
        action: 'reject',
        refresh: false,
        comment: formData?.comment,
        estimated_completion: formData?.estimated_completion,
      });
      reset({});
      closeModal(true);
    } catch (error) {
      ToastMessage.error(error.error || ErrorMessageConstant.defaultAPIError);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      isOpen={open}
      onOpenChange={isOpen => !isOpen && closeModal()}
      size="md"
      isDismissable={false}
      aria-label="Extend Deadline"
    >
      <div className="sk:relative">
        {saving && <LoaderBar content="Saving" />}
        <AppModalHeader className="sk:items-center">
          <div>Extend Deadline</div>
          <AppModalXIcon onClick={() => closeModal()} />
        </AppModalHeader>
        <form
          autoComplete="off"
          noValidate
          onSubmit={handleSubmit(onSubmit)}
          className="sk:my-3 sk:flex sk:flex-col"
        >
          <DateFormField
            error={errors.estimated_completion}
            hint={errors.estimated_completion?.message}
            label="New Date"
            placeholder="Select Date"
            name="estimated_completion"
            defaultValue=""
            minDate={new Date()}
            control={control}
            required
            className="sk:w-full"
            width={16}
          />
          <ControlledTextAreaFormField
            error={errors.comment}
            hint={errors.comment?.message}
            placeholder="Internal Note"
            name="comment"
            control={control}
            width={16}
          />
          <div className="sk:flex sk:justify-end sk:gap-2">
            <Button onPress={() => closeModal()}>Cancel</Button>
            <Button type="submit" variant="primary">
              Extend
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
}
